<template>
  <div class="ui active centered inverted dimmer">
    <div class="ui loader"/>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style scoped>

</style>
